import CryptoJS from "crypto-js";
import { DOMAIN } from "../consts";

export const SECRET_KEY = "53485f4b4559544f484153484032303230";

export const encrypt = (val: string): string => {
  return CryptoJS.AES.encrypt(val, SECRET_KEY).toString();
};

export const decrypt = (val: string) => {
  const bytes = CryptoJS.AES.decrypt(val, SECRET_KEY);
  var result = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return result;
};

const SESSION_DATA: string =
  localStorage.getItem("shipzo_web_session_key_v4") || "";

export const setSession = (user: string) => {
  localStorage.setItem("shipzo_web_session_key_v4", encrypt(user));
  window.location.replace(`${DOMAIN}/`);
};

export const setAcceptSoftwareNondisclosure = () => {
  if (SESSION_DATA) {
    const currentData = decrypt(SESSION_DATA);
    setSession(
      JSON.stringify({
        ...currentData,
        ...{ software_nondisclosure_and_safety_provisions: true },
      })
    );
  }
};

export const logout = () => {
  localStorage.removeItem("shipzo_web_session_key_v4");
  window.location.replace(DOMAIN);
};
export const sessionData = {
  public_id: 3,
  customer_id: 3,
  name: "",
  email: "tester@gentherm.com",
  token: "20eabe5d64b0e216796e834f52d61fd0b70332fc",
  customer_name: "GENTHERM TEXAS",
};

export const USER_ID = SESSION_DATA ? decrypt(SESSION_DATA).public_id : null;
export const CUSTOMER_NAME = SESSION_DATA
  ? decrypt(SESSION_DATA).customer_name
  : null;
export const CUSTOMER_ID = SESSION_DATA
  ? decrypt(SESSION_DATA).customer_id
  : null;
export const USER_NAME = SESSION_DATA ? decrypt(SESSION_DATA).name : null;
export const USER_EMAIL = SESSION_DATA ? decrypt(SESSION_DATA).email : null;
export const USER_TOKEN = SESSION_DATA ? decrypt(SESSION_DATA).token : null;
